import React from 'react';
import MUIDataTable from 'mui-datatables';
import PapperBlock from '../../../../components/PapperBlock/PapperBlock';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import styles from './../reportes-jss'
import { LanguageConsumer, LanguageCxt } from './../../../../language/LanguageContext';

//Filtros
import { renderInput, getSuggestions, renderSuggestion } from './../autocomplete'
import Downshift from 'downshift';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import Grid from '@material-ui/core/Grid';
import { apiPOST, returnCurrentUserId, returnCurrentUser } from '../../../../services/service_base';
import Loader from '../../../../components/Loader/Loader';
import moment from 'moment';

import { textLabelsEs } from '../../../../utils/tableTexts';

import IconButton from '@material-ui/core/IconButton';
import CloudDownload from '@material-ui/icons/CloudDownload';

import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';

class Proyectos extends React.Component {
  state = {
    //Filters
    productor: 0,
    fechaInicio: null,
    fechaFin: null,
    tituloObra: '',
    //Table
    columns: [],
    data: [],
    //Catalogos
    producers: [],
    works: [],
    results: 0,
    isLoading: true,
    body: {
      id_usuario: returnCurrentUserId(),
      user_action: 3,
      work_id: 0,
      portal: 'acervo',
      screen: 'reporteProyectos'
    }
  }

  handleDateChange = date => {
    this.setState({ fechaInicio: date });
  };

  handleDateChangeFin = date => {
    this.setState({ fechaFin: date });
  };

  //Inputs
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleStateChange = changes => {
    if (changes.hasOwnProperty('selectedItem')) {
      this.setState({ tituloObra: changes.selectedItem })
    } else if (changes.hasOwnProperty('inputValue')) {
      this.setState({ tituloObra: changes.inputValue })
    }
  }

  //AHDA 18/02/2018
  handleClearFilters = () => {

    this.setState({
      productor: 0,
      fechaInicio: null,
      fechaFin: null,
      tituloObra: '',
      isLoading: true
    });

    const request = {
      start_date: "0",
      end_date: "0",
      idProducer: 0,
      title: "0"
    }
    this.handleFetch(request);
  }

  searchs = () => {
    this.setState({ isLoading: true })
    var fi = this.state.fechaInicio === null ? 0 : new Date(this.state.fechaInicio);
    var ff = this.state.fechaFin === null ? 0 : new Date(this.state.fechaFin);

    const request = {
      start_date: fi === 0 ? 0 : fi.getDate() + "/" + (fi.getMonth() + 1) + "/" + fi.getFullYear(),
      end_date: ff === 0 ? 0 : ff.getDate() + "/" + (ff.getMonth() + 1) + "/" + ff.getFullYear(),
      idProducer: this.state.productor,
      title: this.state.tituloObra === "" ? "0" : this.state.tituloObra === "TODOS" ? "0" : this.state.tituloObra,

    }
    this.handleFetch(request);
  }

  componentDidMount() {

    const { lang } = this.context;
    this.setState({
      columns: [
        lang.reports.title, lang.reports.producer, lang.reports.assigmentDate, lang.reports.productionYear,
        lang.reports.englishTitle, lang.reports.otherTitle
      ]
    })
    //Catalogo productores
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 17 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ producers: response.data })
        }
        else {
          this.setState({ openError: true });
        }
      }).catch(
        error => {
          this.setState({ openError: true, isLoading: false });
        });

    //Catalogo obras
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 16 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ works: response.data })
        }
        else {
          this.setState({ openError: true });
        }
      }).catch(
        error => {
          this.setState({ openError: true, isLoading: false });
        });

    //Carga inicial
    const request = {
      start_date: "0",
      end_date: "0",
      idProducer: 0,
      title: "0"
    }
    this.handleFetch(request);
  }

  //AHDA 18/02/2019
  handleFetch = (request) => {
    apiPOST('/reports/getByProjects', request).then(
      response => {
        if (response.status === 200) {
          const result = [];
          for (const x in response.data) {
            var obj = [];

            //AHDA 29/04/2019
            //Validation for empty values
            const auxObj = response.data[x]; 
            obj.push(auxObj.title ? auxObj.title : "-");
            obj.push(auxObj.producer ? auxObj.producer : "-");
            obj.push(auxObj.assigment_date ? auxObj.assigment_date : "-");
            obj.push(auxObj.production_year ? auxObj.production_year : "-");
            obj.push(auxObj.english_title ? auxObj.english_title : "-");
            obj.push(auxObj.other_title ? auxObj.other_title : "-");
            result.push(obj);
          }
          this.setState({ data: result, isLoading: false, results: response.data.length })
        } else {
          this.setState({ openError: true, isLoading: false });
        }
      }
    ).catch(
      error => {
        this.setState({ openError: true, isLoading: false });
      }
    );
  }

  render() {
    const { classes } = this.props;
    const { columns, data } = this.state;
    //AHDA 29/04/2019
    //Changed filterType
    const options = {
      filterType: 'multiselect',
      responsive: 'scroll',
      download: false,
      print: false,
      rowsPerPage: 10,
      page: 0,
      selectableRows: false,
      textLabels: textLabelsEs,
      downloadOptions: {
        filename: `Reporte_Proyectos_${moment().format('YYYYMMDD_HHmm')}.csv`,
        filterOptions: {
          useDisplayedRowsOnly: true,
          useDisplayedColumnsOnly: true
        }
      },
      onDownload: (buildHead, buildBody, columns, data) => {
        apiPOST('/audit/add', this.state.body);
        const currentUser = returnCurrentUser();
        const authorName = currentUser ? `${currentUser.nombre} ${currentUser.apellidos}` : '-';
        const generationDate = moment().format('DD/MM/YYYY HH:mm');
        const reportInfo = `"Autor:","${authorName}"\r\n"Fecha:","${generationDate}"\r\n\r\n`;
        return "\ufeff" + reportInfo + buildHead(columns) + buildBody(data);
      },
      customSearch: (searchQuery, currentRow) => {
        let isFound = false;
        const str = searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        currentRow.forEach(col => {
          if (col && col.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(str) >= 0) {
            isFound = true;
          }
        });
        return isFound;
      }
    };
    return (
      <div className="marginTopLogo">
        <LanguageConsumer>
          {
            ({ lang }) =>
              <PapperBlock title={lang.reports.reports} whiteBg desc="">
                {/* Inicio Filtros */}
                <form className={classes.container}>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={6} sm={3} md={3}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                          keyboard={false}
                          // helperText={lang.reports.evDateEnter}
                          helperText={lang.reports.startDate}
                          className={classes.formControl}
                          format="DD/MM/YYYY"
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                          value={this.state.fechaInicio}
                          onChange={this.handleDateChange}
                          disableOpenOnEnter
                          animateYearScrolling={false}
                          disableFuture={true}
                          clearable={true}
                          cancelLabel={lang.common.cancel}
                          clearLabel={lang.common.clear}
                          placeholder="DD/MM/AAAA"
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                          keyboard={false}
                          helperText={lang.reports.endDate}
                          className={classes.formControl}
                          format="DD/MM/YYYY"
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                          value={this.state.fechaFin}
                          onChange={this.handleDateChangeFin}
                          disableOpenOnEnter
                          animateYearScrolling={false}
                          disableFuture={true}
                          clearable={true}
                          minDate={this.state.fechaInicio}
                          disabled={this.state.fechaInicio == null ? true : false}
                          cancelLabel={lang.common.cancel}
                          clearLabel={lang.common.clear}
                          placeholder="DD/MM/AAAA"
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <FormControl className={classes.formControl}>
                        <Select value={this.state.productor} onChange={this.handleChange} name="productor" displayEmpty className={classes.selectEmpty}>
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          {
                            this.state.producers.map((producer, idx) =>
                              (
                                <MenuItem value={producer.value} key={`producer${idx}`}>{producer.data}</MenuItem>
                              ))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.producer}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} className={classes.positionRelative}>
                      <div className={classes.root}>
                        <Downshift selectedItem={this.state.tituloObra} onStateChange={this.handleStateChange}>
                          {({
                            getInputProps,
                            getItemProps,
                            isOpen,
                            inputValue,
                            selectedItem,
                            highlightedIndex
                          }) => (
                              <div className={classes.formControl}>
                                {renderInput({
                                  fullWidth: true,
                                  classes,
                                  // helperText: lang.reports.company,
                                  helperText: lang.reports.title,
                                  InputProps: getInputProps({
                                    // placeholder: lang.reports.company,
                                    placeholder: lang.reports.title,
                                    id: 'titulo',
                                    name: 'titulo',
                                  }),
                                })}
                                {isOpen ? (
                                  <Paper className={classNames(classes.paper, classes.list)} square>
                                    {getSuggestions(inputValue, this.state.works).map((suggestion, index) =>
                                      renderSuggestion({
                                        suggestion,
                                        index,
                                        itemProps: getItemProps({ item: suggestion.label }),
                                        highlightedIndex,
                                        selectedItem,
                                      }),
                                    )}
                                  </Paper>
                                ) : null}
                              </div>
                            )}
                        </Downshift>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={12} sm={12} md={12}>
                      <Button onClick={this.searchs} variant="contained" color="primary" className={classes.button}>
                        {lang.searchs.search}
                      </Button>
                      <Button variant="contained" color="primary" className={classes.button} onClick={this.handleClearFilters}>
                        Limpiar
                  </Button>
                    </Grid>
                  </Grid>
                </form>
                {/* Fin Filtros */}

                <div className={classes.bitacoraMov}>
                  {
                    this.state.isLoading ?
                      <Loader text={"Cargando"} /> :
                      <MUIDataTable title={`${lang.reports.projects} (${this.state.results} ${lang.reports.results})`} data={data} columns={columns} options={options} /> 
                  }
                </div>
              </PapperBlock>
          }
        </LanguageConsumer>
      </div>
    );
  }
}

Proyectos.contextType = LanguageCxt;

export default withStyles(styles)(Proyectos);